<template>
  <span v-if="image" class="cb-single" :style="backgroundClass(image)">
    <div><h3>{{ title }}</h3></div>
  </span>
  <ul v-else :class="{'cb-slideshow': true, 'pattern': currentImage.pattern}">
    <li v-for="(image, ii) in images" v-bind:key="ii">
      <span :style="backgroundClass(image)">Image {{ image.id }}</span>
      <div :style="titleClass(image)"><h3>{{ image.title }}</h3></div>
    </li>
  </ul>
</template>
<script>
export default {
  props: ['images','image', 'title'],
  data: () => ({
      currentImage: {pattern: true}
  }),
  methods: {
    backgroundClass(image) {
      if (typeof image == 'string') return {'background-image': `url(${image})`}
      // determine place of image in array
      let pos = this.images.map(function(x) {
        return x.id;
      }).indexOf(image.id);
      return {
        'animation-name': 'imageAnimation',
        'animation-duration': this.totalBackgroundImages * 6 + 's',
        'animation-delay': pos * 6 + 's',
        'background-image': `url(${image.path})`,
        'animation-iteration-count': 'infinite',
        'animation-fill-mode': 'linear',
      }

    },
  
    titleClass(image) {
      // determine place of image in array
      let pos = this.images.map(function(x) {
        return x.id;
      }).indexOf(image.id);
      return {
        'animation-delay': pos * 6 + 's',
        'animation-name': 'titleAnimation',
        'animation-duration': this.totalBackgroundImages * 6 + 's',
        'animation-iteration-count': 'infinite',
        'animation-fill-mode': 'linear',
      }
    },
  },
  computed: {
    totalBackgroundImages() {
      return this.images.length;
    }
  }
};
</script>
<style>
    .cb-slideshow,
.cb-slideshow:after {
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0px;
  left: 0px;
  z-index: 0;
  list-style: none;
}

.cb-slideshow.pattern:after {
  content: '';
  background: transparent url(/img/pattern.png) repeat top left;
}

.cb-single,
.cb-slideshow li span {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0px;
  left: 0px;
  color: transparent;
  background-size: cover;
  background-position: 50% 50%;
  background-repeat: none;
 
  z-index: 0;
  
}
.cb-slideshow li span {
    animation: imageAnimation 36s linear infinite 0s;
     opacity: 0;
  
}
.cb-single div,
.cb-slideshow li div {
  z-index: 1000;
  position: absolute;
  bottom: 30px;
  left: 0px;
  width: 100%;
  text-align: center;
  opacity: 0;
  color: #fff;
  animation: titleAnimation 36s linear infinite 0s;
}

.cb-slideshow li div h3 {
  font-family: 'BebasNeueRegular', 'Arial Narrow', Arial, sans-serif;
    font-size: 8em;
    padding: 0;
    line-height: 1em;
}
@keyframes imageAnimation {
  0% {
    opacity: 0;
    animation-timing-function: ease-in;
  }
  8% {
    opacity: 1;
    animation-timing-function: ease-out;
  }
  17% {
    opacity: 1;
    transform: scale(1.1) rotate(2deg);
  }
  25% {
    opacity: 0;
    transform: scale(1.1) rotate(2deg);
  }
  100% {
    opacity: 0
  }
}

@keyframes titleAnimation {
  0% {
    opacity: 0;
    transform: translateX(200px);
  }
  8% {
    opacity: 1;
    transform: translateX(0px);
  }
  17% {
    opacity: 1;
    transform: translateX(0px);
  }
  19% {
    opacity: 0;
    transform: translateX(400px);
  }
  25% {
    opacity: 0
  }
  100% {
    opacity: 0
  }
}

@media screen and (max-width: 1140px) {
  .cb-slideshow li div h3 {
    font-size: 100px;
  }
}

@media screen and (max-width: 600px) {
  .cb-slideshow li div h3 {
    font-size: 80px
  }
}
</style>